<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Marketing Staff Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Marketing Staff Details",
            items: [
               {
                  text: "Marketing Staffs",
                  href: "/marketingstaffs",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

         };
      },
      mounted() {
    
      },
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- listing table starts -------->
                  <div class="row">
                     <div class=" col-md-6 col-lg-6">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 <tbody>                                    
                                    
                                    <tr>
                                       <th>Name</th>
                                       <th>:</th>
                                       <td>Alan Joe</td>
                                    </tr>                                                       
                                    <tr>
                                       <th>Mobile</th>
                                       <th>:</th>
                                       <td>+91 9110011222</td>
                                    </tr>           

                                    <tr>
                                       <th>Email</th>
                                       <th>:</th>
                                       <td>alanjoe@xyz.com</td>
                                    </tr>           

                                    <tr>
                                       <th>Whatsapp</th>
                                       <th>:</th>
                                       <td>+91 9110011222</td>
                                    </tr>                      

                                    <tr>
                                       <th>Address</th>
                                       <th>:</th>
                                       <td>Edappalli, Kochi</td>
                                    </tr>           
                                    
                                    
                                    <tr>
                                       <th>Created On</th>
                                       <th>:</th>
                                       <td>05 Mar 2022, 6:30pm</td>
                                    </tr>           

                                 </tbody>
                              </table>
                           </div>
                        </b-card>
                     </div>
                     <div class=" col-md-6 col-lg-6">
                      
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 py-2 px-3 mb-3">ID Proof</h4>

                           <a href="#" target="_blank"><img src="@/assets/images/users/avatar-3.jpg" alt="ID Proof" class="avatar-md"></a>
                        </b-card>
                     </div>
                  </div>
                  <!---- listing table ends -------->

               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
